export const emptyInventoryScreenFilters = {
  state: [],
  years: [],
  types: [],
  severity: [],
  regions: [],
  classifications: [],
  exclusions: [],
  iacTypes: [],
  stacks: [],
  arns: [],
  frns: [],
  owners: [],
  tags: [],
  integrationIds: [],
  providerTypes: {
    providerType: [],
    providerSubType: [],
    provider: [],
    integrationId: [],
  },
  misconfiguration: false,
  reliability: false,
  optimization: false,
  history: false,
  git: false,
  comments: false,
  deletedRange: [],
  module: null,
  deleted: false,
  gitops: false,
  relationship: false,
  masterType: ["cloud"],
  excluded: false,
  vcsId: "",
  vcsRepo: "",
};

export const defaultInventoryColumnVisibilityModel = {
  __check__: true,
  integrationId: true,
  assetType: true,
  name: true,
  arn: false,
  state: true,
  stacks: false,
  region: true,
  assetId: true,
  ownerData: true,
  lastConfigurationChangeTime: false,
  resourceCreationDate: true,
  resourceStatus: true
}